import React, { useState } from 'react';
import { ZoomIn } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { guideSrc } from '@/lib/content';

/* =====================================================================
   GuideImage — rehber ekran görüntüsü (public/img/rehber/{image}-960|1800.webp)
   960/1800 srcset ile gelir, tıklanınca 1800'lük hali dialog'da açılır
   (üzerindeki notlar okunabilsin diye). /nasil-kullanilir ve blog kullanır.
   ===================================================================== */

const IMG_WIDTH = 1800;

const GuideImage = ({ image, height, alt, title = alt, eager = false, sizes = '(min-width: 1024px) 880px, 100vw' }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group relative block w-full overflow-hidden rounded-2xl border border-hairline bg-surface p-2 text-left shadow-card transition-shadow hover:shadow-card-lift focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600"
        aria-label={`${alt} ekran görüntüsünü büyüt`}
      >
        <img
          src={guideSrc(image, 960)}
          srcSet={`${guideSrc(image, 960)} 960w, ${guideSrc(image, 1800)} 1800w`}
          sizes={sizes}
          width={IMG_WIDTH}
          height={height}
          alt={alt}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          className="h-auto w-full rounded-xl"
        />
        <span className="absolute bottom-4 right-4 inline-flex items-center gap-1.5 rounded-full bg-ink-strong/80 px-3 py-1.5 font-inter text-xs font-medium text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">
          <ZoomIn className="h-3.5 w-3.5" aria-hidden="true" />
          Büyüt
        </span>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          className="w-[96vw] max-w-[1600px] grid-cols-1 gap-3 bg-surface p-3 sm:p-4"
          aria-describedby={undefined}
        >
          <DialogTitle className="pr-8 font-poppins text-base font-semibold text-ink-strong">{title}</DialogTitle>
          <img
            src={guideSrc(image, 1800)}
            width={IMG_WIDTH}
            height={height}
            alt={alt}
            className="mx-auto h-auto max-h-[calc(92vh-4rem)] w-auto max-w-full rounded-lg"
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GuideImage;
